/**
 * CRA `public/` file URL. Prefer root-absolute (`/assets/...`).
 * `PUBLIC_URL=.` or empty must not emit `./…` — nested routes like
 * `/dashboard/facilities` would resolve media under `/dashboard/…` and break.
 * `PUBLIC_URL=/` also collapses to root-absolute (avoid `//assets/...`).
 */
export function joinPublicPath(relativePath: string): string {
  const p = relativePath.replace(/^\//, "");
  const raw = (process.env.PUBLIC_URL || "").trim();
  const base = !raw || raw === "." || raw === "/" ? "" : raw.replace(/\/$/, "");
  if (!base) {
    return `/${p}`;
  }
  return `${base}/${p}`;
}

/**
 * Normalize webpack/file-loader asset URLs for nested SPA routes.
 * With `PUBLIC_URL=.`, imports resolve to `static/media/…` (no leading `/`),
 * which the browser resolves under `/dashboard/…` and SPA-falls back to HTML.
 */
export function assetUrl(url: string | undefined | null): string {
  if (url == null || url === "") return "";
  if (
    url.startsWith("http://") ||
    url.startsWith("https://") ||
    url.startsWith("data:") ||
    url.startsWith("blob:") ||
    url.startsWith("/")
  ) {
    return url;
  }
  return `/${url.replace(/^\.\//, "")}`;
}
